<template>
  <div>
    <div  class="main">
      <div class="menu">
        <h3>设置授权</h3>
        <div class="menu-list">
          <el-checkbox class="checkAll" v-if="dynamicGroups.length || cities.length" :indeterminate="isIndeterminate" v-model="checkedAll" @change="handleCheckAllChange">全部</el-checkbox>
          <AuthMenu ref="shopMenu"
                    value-key="name"
                    :menuGroups.sync="cities"></AuthMenu>
          <AuthMenu ref="dynamicMenu"
                    value-key="name"
                    :menuGroups.sync="dynamicGroups"
                    child-name="basics"
                    checkbox-key="code"
                    group-key="groupCode"></AuthMenu>
        </div>
      </div>
      <div class="shop">
        <h3>授权商户</h3>
        <div class="shop-select">
          <el-radio-group v-model="isAllShop" @change="changeShop">
            <el-radio  :label="1">全部店铺</el-radio>
            <el-radio  :label="0">
              <span @click="showSelect">
                <span>部分店铺</span>
                <span>(已选{{isAllShop==0&&shopIds.length?shopIds.length:0}}个)</span>
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="occupy-ele"></div>
    <div class="fixed-bottom-btn">
        <el-button size="medium" type="primary" @click="submit(1)" :disabled="!dynamicGroups.length && !cities.length">批量授权</el-button>
        <el-button size="medium" type="primary" @click="submit(0)" :disabled="!dynamicGroups.length && !cities.length">批量取消授权</el-button>
    </div>

    <el-dialog title="选择店铺"
               :visible.sync="dialogVisible">
      <div class="dialog-content">
        <div  class="floor-list">
          <span v-for="(floor,index) in Floors"
                :key="floor.id"
                :class="[dialog.floorIndex==index?'active':'']" @click="dialog.floorIndex=index">
            {{floor.name}}</span>
          <span @click="dialog.floorIndex=-1" :class="[dialog.floorIndex==-1?'active':'']">全部</span>
        </div>
        <div class="shop-content">
          <label>搜索店铺: </label>
          <el-input size="medium" placeholder="输入店铺名字模糊搜索" v-model="dialog.filterShopVal" @change="filterShop"></el-input>
          <div class="shop-list">
            <el-checkbox :indeterminate="shopIndeterminate" v-if="dialog.shopList.length" v-model="dialog.checkAllShop" @change="handleCheckAllShop">全选</el-checkbox>
            <el-checkbox-group v-model="dialog.checkedShop" class="shop-list_block">
              <el-checkbox v-for="shop in dialog.shopList" :label="shop.id" :key="shop.id" class="shop-list_item">
                <div class="checkbox-label">
                  <span>{{shop.shopName}}</span>
                  <span>{{shop.shopNo}}</span>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="confirmSelect">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import AuthMenu from "./components/AuthMenu";
import {deepClone} from "../../../components/dynamicForm/utils/utils";
export default {
  name: "warrant",
  components: {AuthMenu},
  data(){
    return {
      cities: [],
      fullCities: [],
      dynamicGroups: [],
      checkedAll:false,
      isAllShop:0,
      shopIds:[],
      dialogVisible:false,
      Floors:[],
      dialog:{
        shopList:[],
        checkedShop:[],
        floorIndex:null,
        filterShopVal:'',
        checkAllShop:false
      }
    }
  },

  computed:{
    isIndeterminate:{
      set(val){
      },
      get(){
        this.checkedAll = this.cities.every(e=>!e.isIndeterminate && e.hasModule) && this.dynamicGroups.every(e=>!e.isIndeterminate && e.hasModule)
        const selectLen = this.cities.filter(e=>!e.isIndeterminate && e.hasModule).length + this.dynamicGroups.filter(e=>!e.isIndeterminate && e.hasModule).length  // 全选个数
        return this.cities.some(e=>(e.isIndeterminate))
            || this.dynamicGroups.some(e=>(e.isIndeterminate))
            || (selectLen>0 && selectLen<this.cities.length+this.dynamicGroups.length)
      }
    },

    shopIndeterminate(){
      const shopLen = this.dialog.shopList.length;
      const sum = this.dialog.shopList.reduce((_sum,e)=>{
        this.dialog.checkedShop.includes(e.id) ? _sum++ : '';
        return _sum
      },0)
      this.dialog.checkAllShop = sum === shopLen
      return sum>0 && sum<shopLen
    }
  },

  watch:{
    'dialog.floorIndex':{
      immediate:true,
      handler(val){
        this.dialog.shopList = this.getShopArr(val).filter(e=>(this.dialog.filterShopVal?e.name.includes(this.dialog.filterShopVal):e))
      }
    }
  },

  created () {
    this.getShop()
    this.getAllMenu()
    this.getDynamicMenu()

  },
  methods:{
    // 获取所有非动态表单的菜单
    getAllMenu(){
      this.$api.shopapi.getAllMenuList().then(({data})=>{
        this.fullCities = data;
        this.cities = this.fullCities[0].child[0].child[0].child
      })
    },

    // 获取动态表单的菜单
    getDynamicMenu(){
      this.$api.shopapi.shopDynamicModule().then(({code,data})=>{
        data && (this.dynamicGroups = (data.groups||[]).map(e=>(e.name=e.groupName,e)));
      })
    },

    // 获取楼层和店铺
    getShop(){
      this.$api.check.getFloorShop().then(res => {
        this.Floors = res.data.childList;
        this.dialog.floorIndex = -1
      })
    },

    // 菜单的全选和取消全选
    handleCheckAllChange(val){
      this.isIndeterminate = val;
      this.$refs.dynamicMenu.selectAllGroup(val);
      this.$refs.shopMenu.selectAllGroup(val);
    },
    /*
    *@params type ---1 批量授权   ---0 批量取消授权
    * */
    update(arr,childName,type){
      return deepClone(arr).map(ele=>{
        if(ele[childName] && ele[childName].length){
          ele[childName] = this.update(ele[childName],childName,type)
        }
        ele.hasModule = ele[childName] && ele[childName].length?(ele[childName][type?'some':'every'](ch=>ch.hasModule)):ele.hasModule
        return ele
      })
    },

    // 批量授权 & 批量取消授权
    submit(type){
      if(!this.shopIds.length){
        return this.$message.warning('请选择店铺')
      }
      const dynamicRequest = this.dynamicGroups.length ? this.$api.shopapi.batchDynamicWarrant(type?'post':'delete',{shopIds:this.shopIds,groups:this.update(this.dynamicGroups,'basics',type)}):'';
      const normalRequest = this.cities.length? this.$api.shopapi.batchNormalWarrant(type?'post':'delete',{shopIds:this.shopIds,groups:this.update(this.fullCities,'child',type)}):'';
      (dynamicRequest || normalRequest) && (Promise.all([dynamicRequest,normalRequest]).then((res)=>{
        this.$message.success('操作成功')
        this.reset();
      }))
    },

    // 打开店铺选择弹窗
    showSelect(){
      setTimeout(()=>{
        this.dialog.checkedShop = [...this.shopIds]
        this.dialogVisible = true;
        this.dialog.floorIndex = -1;
      },0)
    },

    // 确认选择店铺
    confirmSelect(){
      this.shopIds = [...this.dialog.checkedShop];
      this.dialog.checkedShop = [];
      this.dialogVisible = false;
    },

    // 根据关键字筛选店铺
    filterShop(val){
      this.dialog.shopList = this.getShopArr(this.dialog.floorIndex).filter(e=>e.name.includes(val))
    },

    // 全选当前楼层的店铺
    handleCheckAllShop(val){
      this.dialog.shopList.forEach(so=>{
        if(val){
          !this.dialog.checkedShop.includes(so.id)?this.dialog.checkedShop.push(so.id):''
        }else{
          const index = this.dialog.checkedShop.findIndex(e=>e===so.id)
          ~index?this.dialog.checkedShop.splice(index,1):''
        }
      })
    },

    getShopArr(val){
      return this.Floors[val]?this.Floors[val].childList:this.Floors.reduce((res,e)=>{res.push(...e.childList);return res},[])
    },

    reset(){
      this.isAllShop = 0;
      this.shopIds = [];
      this.checkedAll = false;
      this.handleCheckAllChange(false)
    },

    changeShop(val){
      this.shopIds = val?this.Floors.reduce((res,e)=>{res.push(...e.childList);return res},[]).map(e=>e.id):[]
    }
  }
}
</script>

<style scoped lang="scss">
.main{
  background: #fff;
  padding: 10px;
  flex: 1;
  overflow-y: auto;
  margin-bottom: -20px;
  .menu{
    .menu-list{
      padding: 10px 16px;
    }
  }
  .shop{
    .shop-select{
      padding: 10px 16px;
    }
  }

}
.dialog-content{
  .floor-list{
    margin: 0 0 10px 0;
    span{
      display: inline-block;
      padding: 5px 12px;
      cursor: pointer;
      &.active{
        background: $subjectColor;
        color: $menuText;
        border-radius: 5px;
      }
    }
  }
  .shop-content{
    padding: 0 5px;
    .el-input{
      width: 320px;
    }
    .shop-list{
      padding: 0 5px;
      .shop-list_block{
        display: flex;
        flex-wrap: wrap;
        .shop-list_item{
          flex: 0 0 20%;
          margin-top: 10px;
          .checkbox-label{
            display: inline-flex;
            flex-direction: column;
          }
        }

      }

    }
  }
}

</style>